
(function waitForjQuery() {
  if (window.jQuery) {
      jQuery( document ).ready( function($) {

        $('.featured-reviews--list').slick({
            dots: false,
            infinite: true,
            speed: 300,
                  slidesToShow: 3,
                  slidesToScroll: 3,
    prevArrow: $('.featured-reviews--section .custom-previous-link'),
    nextArrow: $('.featured-reviews--section .custom-next-link'),
          responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2
                }
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
        });

       $('.product-slider-setup-tabs').slick({
            dots: false,
            infinite: true,
            speed: 300,
                  slidesToShow: 4,
                  slidesToScroll: 4,
          responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3
                }
              },
              {
                breakpoint: 600,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 2
                }
              },
              {
                breakpoint: 540,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            ]
        });

        // Get all tab headers
const tabHeaders = document.querySelectorAll('.tab-header');

// Add click event listener to each tab header
tabHeaders.forEach(header => {
    header.addEventListener('click', function() {
        // Get the tab ID from data attribute
        const tabId = this.getAttribute('data-tab-id');
        
        // Remove active class from all headers
        tabHeaders.forEach(h => h.classList.remove('active'));
        
        // Add active class to clicked header
        this.classList.add('active');
        
        // Remove active class from all tab contents
        document.querySelectorAll('.tab-content').forEach(content => {
            content.classList.remove('active');
        });
        
        // Add active class to corresponding tab content
        const activeContent = document.querySelector(`.tab-content-${tabId}`);
        activeContent.classList.add('active');
        
        // Refresh Slick carousel in the active tab
        const slickCarousel = activeContent.querySelector('.product-slider-setup-tabs');
        if (slickCarousel && $(slickCarousel).hasClass('slick-initialized')) {
            $(slickCarousel).slick('setPosition');
        }
    });
});

      });
  } else {
      setTimeout(waitForjQuery, 50);
  }
})();

